export default __webpack_public_path__ + "static/media/onboarding-aside-mb.2b82e1a9.png";